// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1fVFI","checkboxCol":"Table_checkboxCol__5xCIB","emailCol":"Table_emailCol__2pSaj","actionCol":"Table_actionCol__1anLT"};